import React, { createContext, useContext, ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Create a mock IonRouterContext to satisfy Ionic components
const IonRouterContext = createContext<any>(null);

interface IonicContextProviderProps {
  children: ReactNode;
}

export function IonicContextProvider({ children }: IonicContextProviderProps) {
  const navigate = useNavigate();
  const location = useLocation();

  // Create a mock router object that matches what Ionic expects
  const mockRouter = {
    push: (path: string, direction?: string, animation?: string) => {
      navigate(path, { replace: animation === 'replace' });
    },
    replace: (path: string, direction?: string, animation?: string) => {
      navigate(path, { replace: true });
    },
    back: () => {
      navigate(-1);
    },
    canGoBack: () => {
      return window.history.length > 1;
    },
    // Add other methods that Ionic might expect
    goBack: () => {
      navigate(-1);
    },
    goForward: () => {
      navigate(1);
    },
    // Mock location object
    location: {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state,
    }
  };

  return (
    <IonRouterContext.Provider value={mockRouter}>
      {children}
    </IonRouterContext.Provider>
  );
}

// Hook to use the mock router context
export function useIonRouter() {
  const context = useContext(IonRouterContext);
  if (!context) {
    throw new Error('useIonRouter must be used within an IonicContextProvider');
  }
  return context;
}
